export const SELECTABLE_TYPES = /text|password|search|tel|url/;

export function parseValue(options, value = '') {
  const { parse } = options;

  if (parse) {
    return parse(value, options) || '';
  }

  return value;
}

export function formatValue(options, value = '', parsedValue, prevValue, cursor) {
  const { format, formatter } = options;

  if (formatter) {
    // value - formatter сам парсит значение
    const result = formatter(value, prevValue, cursor, options);
    return {
      value: result.value || '',
      cursor: result.cursor || 0,
    };
  }

  if (format) {
    return {
      value: format(parsedValue, options) || '',
      cursor,
    };
  }

  return {
    value,
    cursor,
  };
}
